import React from 'react';
const isBrowser = () => typeof window !== 'undefined';
const userAgent = isBrowser() ? navigator.userAgent : '';
export const UserAgentContext = React.createContext(userAgent);
//# sourceMappingURL=UserAgentContext.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
